import React, { useEffect, useState } from "react";
import { Box, Icon } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  body: {
    maxWidth: 1024,
  },
  close: {
    padding: 5,
    background: "#00000080",
    color: "#fff",
    transform: "translate(0px, 34px)",
    cursor: "pointer",
  },
  img: {
    maxWidth: "100%",
  },
  bodyMobile: {
    maxWidth: "calc(100% - 16px)",
  },
}));

const Promo = (props) => {
  const classes = useStyles();
  const model = props.model;
  const handleClose = () => {
    window.parent.postMessage(
      { type: "form", key: "close", value: { id: model.id } },
      "*"
    );
  };
  return (
    <Box display="flex" flexDirection="column" alignItems="end">
      <Icon className={classes.close} onClick={handleClose}>
        close
      </Icon>
      <a
        href={model.actionValue}
        target={model.action == 1 ? "_blank" : "_parent"}
        onClick={() => {
          setTimeout(() => {
            handleClose();
          }, 1000);
        }}
      >
        <img
          className={classes.img}
          alt=""
          title={model.header1}
          src={model.image}
        />
      </a>
    </Box>
  );
};
export default Promo;
